module.exports = __webpack_public_path__ + "static/media/outlet-policy.b7fd1038.svg";